module.exports = __webpack_public_path__ + "static/img/ent-19.770eca2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-19.jpg
// module id = PoP0
// module chunks = 52